<!-- 查询学生信息页面 -->
<template>
    <div class="home">
        <Head :logo='logo'></Head>
            <van-field
                class="search"
                v-model="queryInfo.idCard"
                center
                clearable
                required
                placeholder="请输入证件号码"
                v-on:keyup.enter="queryStudent()"
            >
                <template #button>
                    <van-button size="small" type="info" @click="queryStudent()">查询</van-button>
                </template>
            </van-field>
            <PrivacyDialog person='1' @getReadState='getReadState'></PrivacyDialog>
            <div v-if='studentList.length > 0' style="margin-top: 10px;">
                <div class="form" v-for='(item,index) in studentList' :key='index'>
                    <div class="title" @click="showDetail(item)">
                        <div>
                            <span>{{item.idCard}}</span>
                        </div>
                        <span>{{item.name}}</span>
                    </div>
                    <div class="contentbox" @click="showDetail(item)">
                        <div class="">
                            <span>年级：</span>
                            <span>{{item.gradeName}}</span>
                        </div>
                        <div class="">
                            <span>班级：</span>
                            <span>{{item.clazzName}}</span>
                        </div>
                        <div class="split">
                            <span>所在院校：</span>
                            <span>{{item.deptName}}</span>
                        </div>
                    </div>
                    <div class="cu-form-group">
                        <div @click="viewHistory(item,index)">查看历史已缴费</div>
                        <div @click="goChoosePay(item,index)">去缴费</div>

                    </div>
                </div>
            </div>

            <van-cell class="tologin">
                <div>
                    数据未录入系统？
                    <van-button @click="goRegister()" type="primary" size='small'>点我注册</van-button>
                </div>
            </van-cell>

            <van-popup v-model="showChooseDept" round position="bottom">
                <van-picker
                    title="选择注册学校"
                    show-toolbar
                    :columns="deptNameList"
                    @confirm="onDeptConfirm"
                    @cancel="onDeptCancel"
                />
            </van-popup>
            <van-popup v-model="showChooseCharge" round  style="width: 85%;">
                <div class="popup">
                    <van-form @submit="chargePay">
                             <van-field
                                readonly
                                clickable
                                name="picker"
                                label-class='formTitle'
                                :value="chargeName"
                                label="收费项"
                                placeholder="点击选择收费项"
                                @click="showPickerOne = true"
                            />
                            <van-field
                                v-model="payBody.period"
                                label-class='formTitle'
                                label="费用年度"
                                disabled
                            />
                            <van-field
                                v-model="payBody.quarterName"
                                label-class='formTitle'
                                label="费用季度"
                                disabled
                            />
                            <van-field
                                v-model="payBody.startDate"
                                label-class='formTitle'
                                label="开始时间"
                                disabled
                            />
                            <van-field
                                v-model="payBody.endDate"
                                label-class='formTitle'
                                label="截止时间"
                                disabled
                            />
                            <van-field
                                v-model="payBody.actualTotal"
                                label-class='formTitle'
                                label="收费金额"
                                disabled
                            />
                            <van-field
                                v-model="payBody.studentId"
                                label-class='formTitle'
                                label="学生学号"
                                disabled
                                v-show="false"
                            />
                        <van-button round block type="info" native-type="submit" :disabled="isPay"  class="btn">
                            去支付
                        </van-button>
                    </van-form>
                </div>
            </van-popup>

        <div id="widget" />
        <van-popup v-model="showPickerOne" position="bottom">
            <van-picker
            show-toolbar
            :columns="chargeList"
            @confirm="onConfirmOne"
            @cancel='showPickerOne=false'
            />
        </van-popup>
        <Foot  v-if='list && list.bottomMessage && list.bottomMessage.length>0' :list='list'></Foot>
    </div>
</template>

<script>
    import Head from '@/components/head'
    import Foot from '@/components/foot'
    import selectPicker from '@/components/selectPicker'
    import {Toast,Dialog} from "vant";
    import {isEmpty,asyncLoadJs} from "../../utils/common";
    import {judgeVde} from "@/utils/publicJudge";
    import PrivacyDialog from '@/components/dialog/privacyDialog'
    import { savePrivacy } from "@/utils/common";
    export default {
        name: "query",
        components: {
            Head,
            Foot,
            selectPicker,
            PrivacyDialog
        },
        data() {
            return {
                logo:'',
                vde:'',
                queryInfo:{
                  idCard:''
                },
                loadedMineMapJs:false,
                showPickerOne:false,
                deptList:[],
                deptNameList:[],
                showChooseDept:false,// 控制选择单位注册的弹窗是否显示
                list:[],// 微信底部信息
                studentList:[],
                showChooseCharge:false,// 控制选择缴费的弹窗是否显示
                chargeList:[],// 学校收费项列表
                chargeMap :[],// 学校收费项
                payBody:{//选中学校收费项相关信息
                    chargeId:'',
                    period:'',//费用年度
                    quarterName:'',// 费用季度
                    actualTotal:'',//个人应收总额
                    startDate:'',//费用开始时间
                    endDate:'',//费用截止时间
                    studentId:''//缴费人
                },
                chargeName:'',
                isPay:false,
                isRead:false,
                 details:[],
            }
        },
        created() {
            if (this.$route.query.vde === undefined) {
                this.vde = ''
            }else {
                this.vde = this.$route.query.vde
            }
            //判断vde
            judgeVde({vde:this.vde},this)
            this.getLock()
            this.getHeadImg()
            this.getFootData()
        },
        methods:{
             getReadState(isRead,details) {
                this.isRead = isRead;
                this.details = details;
            },
             getLock() {
                let data={
                    deptId:this.vde,
                    type:0
                }
                this.request({
                    url:'/specialPay/isEnableSpecialPay',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code!=1000) {
                        Dialog.alert({
                            title: '提示',
                            message: res.data.message,
                        }).then(() => {
                            this.$router.push({path:'/404'})
                        });
                    }
                })
            },
            onConfirmOne(value) {
                 const charge = this.chargeMap.get(this.payBody.chargeId)
                if(isEmpty(value) || value == null){
                    Toast.clear();
                    Dialog.alert({
                        title: "提示",
                        message: "获取收费项出错，请刷新后重试"
                    }).then(() => {});
                    return;
                }else{
                    this.payBody.chargeId = value.uId
                    this.payBody.period = value.period
                    this.payBody.quarterName = value.quarterName
                    this.payBody.actualTotal = Number(value.actualTotal).toFixed(2)
                    this.payBody.startDate = value.startDate
                    this.payBody.endDate = value.endDate
                    this.payBody.studentId = this.payBody.studentId
                    this.chargeName = value.chargeName
                    this.showPickerOne = false
                }
            },
            savePrivacy() {
                let data = {
                    details:this.details,
                    userId:this.queryInfo.idCard,
                    userName:this.queryInfo.idCard,
                }
                savePrivacy(data);
            },
            // 查询学生信息
            queryStudent(){
                if (this.isRead == false) {
                    Dialog.alert({
                    title: "提示",
                    message: "请先阅读《用户隐私政策》",
                    }).then(() => {});
                    return;
                }
                if (this.queryInfo.idCard=='') {
                     Dialog.alert({
                            title: "提示",
                            message: '请输入证件号码'
                        }).then(() => {});
                }else {
                    Toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0,
                    });
                    this.request({
                        url:'/prepaid/listStudentByIdCard',
                        method:'get',
                        params: {idCard:this.queryInfo.idCard,vde:this.vde}
                    }).then((res)=>{
                            Toast.clear();
                        if (res.data.code == 1000) {
                            this.savePrivacy();
                            this.studentList = res.data.result
                        }else{
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message
                            }).then(() => {});
                        }

                    })
                }
            },
            //查看历史已缴费记录
            viewHistory:function (obj,index) {
                this.$router.push({path:'/pages/prepaid/history?mark='+obj.uId +"&vde=" + this.vde})
            },
            //去缴费
            goChoosePay:function (obj,index) {
                this.resetPayBody()
                this.isPay = false
                if(this.chargeList.length <=0){
                    this.request({
                        url:'/prepaid/listPrepaidChargeByDeptId',
                        method:'get',
                        params:{deptId:obj.deptId}
                    }).then((res)=>{
                        this.chargeList = []
                        this.chargeMap = new Map();
                        if (res.data.code == 1000) {
                            if(res.data.result == null || res.data.result.length <=0){
                                Toast.clear();
                                Dialog.alert({
                                    title: "提示",
                                    message: "该单位暂无可缴费的学校收费项"
                                }).then(() => {});
                                this.showChooseCharge = false
                            }else{
                                this.chargeList = res.data.result
                                this.showChooseCharge = true
                                let m = new Map()
                                this.chargeList.forEach(c =>{
                                    m.set(c.uId,c);
                                    c.text = c.chargeName
                                })
                                this.chargeMap = m
                                this.payBody.studentId = obj.uId
                            }

                        }else{
                            Toast.clear();
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message
                            }).then(() => {});
                            this.showChooseCharge = false
                            return ;
                        }
                    })
                }else{
                    this.payBody.studentId = obj.uId
                    //弹框
                    this.showChooseCharge = true
                }
            },
            // 选择收费项后去支付
            chargePay:function(){
                this.isPay = true;
                if(isEmpty(this.payBody.chargeId)){
                    Toast.clear();
                    Dialog.alert({
                        title: "错误提示",
                        message: "请选择需要支付的收费项"
                    }).then(() => {
                        this.isPay = false;
                    });
                    return;
                }else{
                    this.request({
                        baseURL: process.env.VUE_APP_PAY_URL,
                        url:'/pay/payInitPrepaid',
                        method:'post',
                        data:{chargeId:this.payBody.chargeId,studentId:this.payBody.studentId}
                    }).then((res)=>{
                        if (res.data.code == 1000) {
                            Toast.loading({
                                message: "创建订单中...",
                                forbidClick: true,
                                duration: 0
                            });
                            this.showChooseCharge = false
                            const result = res.data.result
                            if (!this.loadedMineMapJs) {
                                asyncLoadJs(result.thirdpayWidgetJs).then(() => {
                                    this.loadedMineMapJs = true;
                                    this.initPay(result);
                                });
                            }else{
                                this.initPay(result);
                            }
                        }else{
                            Toast.clear();
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message
                            }).then(() => {
                                this.isPay = false
                            });
                            return ;
                        }
                    })
                }
            },
            // 重置学校收费项dialog
            resetPayBody:function(){
                this.payBody = {
                    chargeId:'',
                    periodName:'',
                    quarterName:'',
                    actualTotal:'',
                    startDate:'',
                    endDate:'',
                    studentId:''
                }
                this.chargeName="";
            },
            // 去注册
            goRegister:function(){
                if(this.deptList.length <= 0){
                    this.request({
                        url:'/prepaid/listEduDept',
                        method:'get',
                        params:{vde:this.vde}
                    }).then((res)=>{
                        this.deptList = []
                        this.deptNameList = []
                        if (res.data.code == 1000) {
                            this.deptList = res.data.result
                            const list = []
                            this.deptList.forEach(dept =>{
                                list.push("[" + dept.deptId + "]" + dept.deptName)
                            })
                            this.deptNameList = list
                            this.showChooseDept = true
                            setTimeout(()=>{
                                $('.van-ellipsis').each((i,val)=>{
                                    if($(val).html().length>20) {
                                        var scrollWidth = $(val).parent().width();
                                        var textWidth = $(val).width();
                                        var i = scrollWidth;
                                        setInterval(function() {
                                            i--;
                                            if(i < -textWidth ) {
                                                i = scrollWidth;
                                            }
                                            $(val).animate({'left': i+'px'}, 10);
                                        }, 20);
                                        $(val).css({'position':'relative','white-space':'nowrap'})
                                        $(val).removeClass('van-ellipsis')
                                    }
                                })
                            },0)
                        }else{
                            Dialog.alert({
                                title: "提示",
                                message: res.data.message
                            }).then(() => {});
                            this.showChooseDept = false
                        }
                    })
                }else{
                    this.showChooseDept = true
                }
            },
            // 选择单位点确定
            onDeptConfirm:function(value, index){
                this.showChooseDept = false;
                if((index + 1) > this.deptList.length){
                    Toast.clear();
                    Dialog.alert({
                        title: "提示",
                        message: "获取单位出错，请刷新后重试"
                    }).then(() => {});
                    return false;
                }
                const dept = this.deptList[index];
                //跳转到注册页面
                this.$router.push({path:'/pages/prepaid/register?deptId='+dept.deptId + "&deptName=" + dept.deptName +"&vde=" + this.vde})
            },
            // 选择单位点取消
            onDeptCancel:function(){
                this.showChooseDept = false
            },
            getHeadImg() {
                let data = {};
                data.vde = this.vde;
                this.request({
                    url:'/webPortal/websitConfig',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code == 1000) {
                    if (res.data.result.logoUrlLogin) {
                        this.logo = res.data.result.logoUrlLogin;
                    }else {
                        this.logo = require("@/assets/img/logo.png");
                    }
                    document.title=res.data.result.websitTitle
                    sessionStorage.setItem("title", res.data.result.websitTitle);
                    } else if (res.data.code != 1000){
                    this.$router.push({ path: "/404" });
                    }
                })
                },
            // 获取底部数据
            getFootData() {
                let data = {
                    vde:this.vde,
                    type:1
                }
                this.request({
                    url:'/systemManage/mobileGetMessage',
                    method:'get',
                    params:data
                }).then((res)=>{
                    if (res.data.code != 1000) {
                        //this.$router.push({path:'/404'})
                    }else {
                        this.list=res.data.result
                    }
                })
            },
            // 支付
            initPay:function(res) {
                let obj = {
                    container: "widget", // 挂件在当前页面放置的控件ID
                    merchant_no: res.merchant_no, // 分配的商户号
                    merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
                    amount: res.amount, // 订单价格，单位：人民币 分
                    widget_param: res.widget_param,
                    subject: res.subject,
                    body: res.body,
                    charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
                    charge_param: res.charge_param,
                    device_type: res.device_type, // 设备类型
                    effective_time: res.effective_time, // 当天有效，24点失效
                    version_no: res.version_no
                };
                let that = this;
                const interval = setInterval(() => {
                    if (this.loadedMineMapJs) {
                        clearInterval(interval);
                        // 调起支付
                        thirdpay_widget.init(obj);
                        Toast.clear();
                        that.isPay = false;
                    }
                }, 100);
            },
            showDetail:function (student) {
                var configList = student["studentFieldList"];
                var studentMsg = "";
                studentMsg += "<div style='text-align:left;'>"
                //该单位未配置学生字段，则使用默认的必填几个参数
                if(undefined == configList || null == configList || configList.length <= 0){
                    studentMsg += "姓名：" + student.name +"<br/>";
                    studentMsg += "证件号码：" + student.idCard +"<br/>";
                    studentMsg += "年级：" + student.gradeName +"<br/>";
                    studentMsg += "班级：" + student.clazzName +"<br/>";
                }else{
                    for(var i = 0 ;i < configList.length ; i++){
                        var config = configList[i];
                        var fieldName = config['fieldName'];
                        var msg = "";
                        switch (fieldName) {
                            case 'sex':
                                msg = student[fieldName] == '0'?'女':'男';
                                break;
                            case 'clazz':
                                msg = student['clazzName'] == null ?"":student['clazzName'];
                                break;
                            case 'grade':
                                msg = student['gradeName'] == null ?"":student['gradeName'];
                                break;
                            default:
                                msg = student[fieldName] == null ?"":student[fieldName];
                                break;
                        }
                        studentMsg += config["showName"] + ":" + msg + "<br/>"
                    }
                }

                studentMsg += "</div>";
                Toast.clear();
                Dialog.alert({
                    title: "学生详细信息",
                    message: studentMsg
                }).then(() => {
                });
            }
        }
    }
</script>

<style lang="scss">
     .formTitle {
        padding-right: 40px;
        text-align-last: justify;
    } 
    .home {
        padding: 0 2vw;
        box-sizing: border-box;
    }
    .search {
        background:rgba(255,255,255,1);
    }
    .tologin {
        background:rgba(255,255,255,1);
    }
    .popup {
        padding: 30px 15px;
    }
    .btn {
        margin-top: 20px;
    }
    .form {
        width: 94vw;
        position: relative;
        left: 50%;
        margin-left: -47vw;
        border-radius:2px;
        box-sizing: border-box;
        margin-bottom: 20px;
        background:rgba(255,255,255,1);
        box-shadow:4px 4px 5px 0px rgba(51,51,51,0.05);
        border-radius:5px;
        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height:32px;
            box-sizing: border-box;
            padding: 0 14px;
            border-radius:2px 2px 0px 0px;
            background:#1989fa;
            >div {
                image {
                    width: 14px;
                    margin-right: 13px;
                    position: relative;
                    top: 2px;
                }
            }
            span {
                font-size:14px;
                font-family:PingFang SC;
                font-weight:400;
                color:rgba(255,255,255,1);
                line-height:31px;
            }
        }
        >.contentbox {
            padding: 10px 14px 0 14px;
            font-size: 14px;
            >div {
                height: 30px;
                line-height: 30px;
                > span:nth-of-type(1) {
                    display: inline-block;
                    width: 80px;
                    text-align: justify;
                    font-size:14px;
                    font-family:PingFang SC;
                    color:rgba(102,102,102,1);
                    vertical-align: top;
                    &::after {
                         display: inline-block;
                         width: 100%;
                         content: '';
                         height: 0;
                     }
                }
                >span:nth-of-type(2) {
                    color:rgba(51,51,51,1);
                    margin-left: 18px;
                    display: inline-block;
                }
            }

            .split {
                padding-bottom: 10px;
                border-bottom: 1px dashed #C8C8C8;
                >span:nth-of-type(2) {
                    color: #FF774D;
                }
            }
        }
        .cu-form-group {
            display: flex;
            justify-content: space-between;
            padding: 15px;
            align-items: center;
            position: relative;
            z-index: 99;
            >div {
                font-size:13px;
                font-family:PingFang SC;
                color:rgba(8,148,235,1);
            }
        }
    }

</style>